// frontend/src/components/CandidateAchievements.jsx
import React from "react";

const CandidateAchievements = ({ achievements = [] }) => {
  if (!achievements.length) return null;

  return (
    <div className="mt-6">
      <h2 className="text-xl font-semibold mb-3 border-b pb-1 text-orange-700">
        🏆 Achievements & Initiatives
      </h2>
      <ul className="space-y-2 list-disc pl-5 text-sm text-gray-700">
        {achievements.map((item, index) => (
          <li key={index}>
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CandidateAchievements;
